import { slugify } from './slug';

interface MdastNode {
  type: string;
  depth?: number;
  value?: string;
  children?: MdastNode[];
  data?: { hName?: string; hProperties?: Record<string, unknown> };
}

function textOf(node: MdastNode): string {
  if (node.type === 'text' || node.type === 'inlineCode') {
    return node.value ?? '';
  }
  return (node.children ?? []).map(textOf).join('');
}

function collectHeadings(node: MdastNode, out: MdastNode[]): void {
  if (node.type === 'heading' && (node.depth === 2 || node.depth === 3)) {
    out.push(node);
  }
  node.children?.forEach((child) => collectHeadings(child, out));
}

/** remark plugin: gives every `##`/`###` heading a deterministic, per-document
 * `id` (via `slugify`), deduped in document order with `-2`, `-3` suffixes. */
export function remarkHeadingIds() {
  return (tree: MdastNode) => {
    const headings: MdastNode[] = [];
    collectHeadings(tree, headings);

    const seen = new Map<string, number>();
    for (const heading of headings) {
      const base = slugify(textOf(heading));
      const count = (seen.get(base) ?? 0) + 1;
      seen.set(base, count);
      const id = count === 1 ? base : `${base}-${count}`;
      heading.data = {
        ...(heading.data ?? {}),
        hProperties: {
          ...(heading.data?.hProperties ?? {}),
          id,
        },
      };
    }
  };
}
